<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>
    <Introduce :Introduce="company_introduction"></Introduce>
    <Introduce :Introduce="big_data_team_strength"></Introduce>
    <CorporateCulture></CorporateCulture>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"
  import Introduce from "@/components/About_Us/Introduce"
  import CorporateCulture from "@/components/About_Us/CorporateCulture"

  export default {
    name: 'About_Us',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-aboutus.png"),
        company_introduction: {
          title: "公司简介",
          contents: ["苏州瑞鹏信息技术有限公司（www.raipeng.com）成立于2013年1月，是一家专注于移动互联网商务服务和大数据资源整合、应用、开发、服务和运营的高新技术企业，专业提供搭建大数据应用与服务平台，以实现数据挖掘、数据整理、大数据分析、精准营销、跨领域数据融合、供应链重组与整合等各方面应用。","公司是苏州市认定的大数据企业，特别在金融领域精准数据分析与挖掘有独特的资源与技术积累，已与民生银行、中信银行、兴业银行、浦发银行、光大银行、平安银行等签订合作协议，为其提供定制的大数据服务","公司致力于为金融行业、政府机构等提供有竞争力的大数据解决方案，不断提升客户体验，为客户创造最大价值，开启智慧大数据的未来。",
          ],
          class: "FFFFFF"
        },
        big_data_team_strength: {
          title: "大数据团队实力",
          contents: ['    瑞鹏信息管理人员来自于知名品牌企业，拥有科技、法律、管理等领域深厚的专业知识背景和丰富的从业经验，能够为行业客户提供优质的大数据解决方案',"该团队主要由数据技术、数据产品、算法挖掘、运营平台团队组成，目前共有40多位优秀的工程师。","团队核心成员均达到十年以上基础数据研究经验，专注于大数据算法、数据模型及网络通信技术研究，专注于行业数据增值业务的探索与实践，我们致力于成为行业最佳数据解决方案供应商，让数据更智慧。"],
          class: "F4F4F4"
        }
      }
    },
    components: {
      Header, Banners,Footer,Introduce,CorporateCulture
    },
    created() {
      this.$store.commit('changeNavs', 'About_Us')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    min-width: 1350px;
  }
</style>



// WEBPACK FOOTER //
// src/views/About_Us.vue